import { InferType, object, string } from 'yup';

import { USERNAME_VALIDATION_REGEX } from '@modules/auth/constants';

const CreateUsernameSchema = object({
  username: string()
    .required('Username is required')
    .min(4, 'Username must be at least 4 characters')
    .max(32, 'Username must be at most 32 characters')
    .matches(
      USERNAME_VALIDATION_REGEX,
      'Username must have at least 3 letters and only use letters, numbers, dashes, dots, and underscores'
    ),
});

export type CreateUsernameSchemaType = InferType<typeof CreateUsernameSchema>;

export { CreateUsernameSchema };
